let isPaused = false;

function animate(item) {
    let position = 0;
    const itemWidth = item.getBoundingClientRect().width;
    const wrapper = document.querySelector('[data-announcements-wrapper]');
    const wrapperWidth = wrapper.getBoundingClientRect().width;
    
    

    function step() {
        if (!isPaused) {
            position -= .5;
            
            // position += 2; // Move 2px per frame
            item.style.left = position + 'px';
    
            if (position < -itemWidth) {
                // position = containerWidth;
                position = wrapperWidth;
            }
        }
        
        requestAnimationFrame(step); // Call the next frame
        
    }
    step();
  }

export default function AnnouncementsHandler() {
    const container = document.querySelector('[data-announcements-container]');
    
    if (container) {
        container.addEventListener('mouseenter', () => isPaused = true);
        container.addEventListener('mouseleave', () => isPaused = false);

        animate(container);
    }
}